import { MARKETING_GET_PRIMARY_INTERESTS_SUCCESS } from './type'

//eslint-disable-next-line
export default function (
  state = {
    primaryInterests: [],
  },
  action,
) {
  const { payload, type } = action

  switch (type) {
    case MARKETING_GET_PRIMARY_INTERESTS_SUCCESS:
      return { ...state, primaryInterests: payload.response }
    default:
      return state
  }
}
